import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const availabilityParams = {
    date: '2021-05-11',
    lat: -89.781,
    lng: 179.339,
};

const initialState = {
    availability: { Success: false, Data: { Count: 0 } },
    status: 'idle',
    error: null,
    params: availabilityParams,
};

export const fetchMyAvailability = createAsyncThunk(
    'teacher/fetchMyAvailability',
    async token => {
        const response = await axios.get('/myAvailability', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/myAvailability`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    }
);
// need to obtain token silently before the API call and remove from availability page
export const addAvailability = createAsyncThunk(
    'teacher/addAvailability',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.post('/addAvailability', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: '/addAvailability',
            timeout: 30000,
            headers: headers,
        });
        return await response;
    }
);

export const editAvailability = createAsyncThunk(
    'teacher/editAvailability',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.put('/editAvailability', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: '/editAvailability',
            timeout: 30000,
            headers: headers,
        });
        return await response;
    }
);

export const deleteAvailability = createAsyncThunk(
    'teacher/deleteAvailability',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.delete(
            process.env.REACT_APP_API_GATEWAY + '/deleteAvailability',
            {
                data: data.request,
                timeout: 30000,
                headers: headers,
            }
        );
        return await response;
    }
);

const availabilitySlice = createSlice({
    name: 'availability',
    initialState,
    reducers: {
        availabilityAdded(state, action) {
            const {
                grade,
                address,
                teacherName,
                teacherProfile,
                skills,
                otherSkills,
                bio,
                geoJSON,
                startDate,
                endDate,
                status,
                repeat,
                pk1,
                sk1,
            } = action.payload;
            const currentAvailability = state.availability;
            if (currentAvailability) {
                currentAvailability.otherSkills = otherSkills;
                currentAvailability.address = address;
                currentAvailability.teacherName = teacherName;
                currentAvailability.teacherProfile = teacherProfile;
                currentAvailability.skills = skills;
                currentAvailability.bio = bio;
                currentAvailability.grade = grade;
                currentAvailability.geoJSON = geoJSON;
                currentAvailability.startDate = startDate;
                currentAvailability.endDate = endDate;
                currentAvailability.repeat = repeat;
                currentAvailability.status = status;
                currentAvailability.sk1 = sk1;
                currentAvailability.pk1 = pk1;
            }
        },
        updateStatus(state, action) {
            console.log('update status slice ', action);
            var interimState = state.availability.Data;
            const indexNumber = interimState.findIndex(
                x => x.uniqueId === action.payload.id
            );

            interimState[indexNumber].status = action.payload.status;

            console.log('New Array ' + JSON.stringify(interimState));
        },
        removeAvailability(state, action) {
            console.log('removing availabilities ');
            state.status = 'idle';
            state.availability.Data = { Data: { Count: 0 }, Success: false };
        },
    },
    extraReducers: {
        [fetchMyAvailability.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchMyAvailability.fulfilled]: (state, action) => {
            state.status = 'succeeded';
            // Add any fetched posts to the array
            console.log(
                'Need to format date into this ' +
                    JSON.stringify(action.payload.availability.Message)
            );

            state.availability = action.payload.availability.Message;
        },
        [fetchMyAvailability.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        [addAvailability.fulfilled]: (state, action) => {
            var interimState = state.availability.Data;
            var newAddedAvails = action.payload.data.availability;
            //var finalData = interimState.replace(/\\/g, "");
            //var parseable = JSON.parse(interimState);

            //Fix this by using the map statement instead of a push in a map statement
            newAddedAvails.forEach(item => {
                if (item.Message.Success === true) {
                    interimState.push(item.Message.Data);
                }
            });

            state.availability.Data = interimState;
            console.log('Final dates' + JSON.stringify(interimState));
        },
        [editAvailability.fulfilled]: (state, action) => {
            var interimState = action.payload.data.availability;
            console.log('payload ' + JSON.stringify(interimState));

            const editedArray = state.availability.Data.map(element => {
                if (element.sk1 === interimState.Message.Data.sk1) {
                    element.startDate = interimState.Message.Data.startDate;
                    element.endDate = interimState.Message.Data.endDate;
                }
                return element;
            });

            state.availability.Data = editedArray;
        },
        [deleteAvailability.fulfilled]: (state, action) => {
            var deleteItems = action.payload.data.Message.Data;

            console.log('action', JSON.stringify(action.payload.data));
            console.log(
                'availability',
                JSON.stringify(state.availability.Data)
            );

            const interimArray = state.availability.Data.filter(element => {
                if (deleteItems.some(item => item.data === element.uniqueId)) {
                    return false;
                } else {
                    return true;
                }
            });

            console.log('New Array ' + JSON.stringify(interimArray));

            state.availability.Data = interimArray;
        },
    },
});

export const { availabilityAdded, updateStatus, removeAvailability } =
    availabilitySlice.actions;

export default availabilitySlice.reducer;

export const getAvailability = state => state.availability;
